'use client';

import { c as _c } from "react/compiler-runtime";
import { RefreshRouteOnSave as PayloadLivePreview } from '@payloadcms/live-preview-react';
import { useRouter } from 'next/navigation';
import type React from 'react';
import { getClientSideURL } from '@/payload/utils/getURL';
export const LivePreviewListener: React.FC = () => {
  const $ = _c(3);
  const router = useRouter();
  const t0 = router.refresh;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getClientSideURL();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== router.refresh) {
    t2 = <PayloadLivePreview refresh={t0} serverURL={t1} />;
    $[1] = router.refresh;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};